import { useRoutes } from "react-router";
import { AuthProvider } from "./pages/Auth";
import { routes } from "@/router";
import { ToastContainer } from "@/ui-kit";
import { CookieContextProvider } from "@/context/CookieContext";
import { Cookies } from "@/pages/Legal/components/Cookies";
import { useAppStore } from "@/store/app/slice";
import { ComponentsLocaleProvider } from "./ui-kit";
import { useTranslation } from "react-i18next";
import { PrivacyConsent } from "@/components/PrivacyConsent";

const App = () => {
  const { t } = useTranslation();
  const router = useRoutes(routes);
  const showCookiesBanner = useAppStore((s) => s.showCookiesBanner);

  return (
    <ComponentsLocaleProvider language="en" t={t}>
      <CookieContextProvider>
        <AuthProvider>
          <div className="nuco-app">{router}</div>
          <ToastContainer />
          {showCookiesBanner && <Cookies />}
          <PrivacyConsent />
        </AuthProvider>
      </CookieContextProvider>
    </ComponentsLocaleProvider>
  );
};

export default App;
